<template>
    <div class="navbar-container">
        <div class="navbar-box">
            <div class="all-menu">
                全部商品分类
                <ul :class="navType == 0
                        ? 'all-menu-list'
                        : 'all-menu-list all-menu-list-hide'
                    ">
                    <li class="all-list-item" v-for="(item, index) in navbarList" :key="index">
                        <i :class="item.icon" class="list-icon"></i>
                        <span class="first-title" v-for="(itemOneName, indexOneName) in item.name" :key="indexOneName"
                            @click="goDetail(itemOneName)">
                            {{ itemOneName.name }}</span>

                        <div class="all-list-son" v-for="(itemOne, indexOne) in item" :key="indexOne">
                            <span class="son-title" v-for="(itemSt, indexSt) in item.name" :key="'info2-' + indexSt">{{
                                itemSt.name }}</span>
                            <div class="list-son-detail" v-for="(itemDetail, indexDetail) in itemOne" :key="indexDetail">
                                <div class="son-detail-title">
                                    <p class="second-title" @click="goDetail(itemDetail)">
                                        {{ itemDetail.name }}&nbsp;&nbsp;>
                                    </p>

                                    <div class="third-box">
                                        <span class="third-title" v-for="(
                                                itemss, indexss
                                            ) in itemDetail.nodes" :key="indexss" @click="goDetail(itemss)">{{
                                                itemss.name }}</span>
                                    </div>
                                </div>
                                <!-- <p>{{ itemDetail.item }}</p> -->
                                <div class="son-detail-item" v-for="(itemDI, indexDI) in itemDetail.item" :key="indexDI">
                                    {{ itemDI.name }}
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="home-menu flex1">
                <div class="home-menu-item" v-for="(itemHome, indexHome) in homeMenu" :key="indexHome"
                    @click="jumpUrl(itemHome)">
                    <div :class="itemHome.link == current_url
                            ? 'flex_center home-menu-item-active'
                            : 'flex_center'
                        ">
                        <i :class="itemHome.icon"></i>
                        <!-- 使用后台获取动态菜单使用 -->
                        <!-- <img class="icon" v-if="itemHome.icon" :src="$imgpath+itemHome.icon" /> -->
                        {{ itemHome.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "navbar",
    components: {},
    data() {
        return {
            current_url: "",
        };
    },
    props: ["navbarList", "navType", "homeMenu"],
    created() {
        //console.log(this.$route.path)
        // this.current_url = this.$route.path.substr(1);
        if (this.$route.path == '/zone') {
            this.current_url = '/zone?title=福利专区';
        } else {
            this.current_url = this.$route.path;
        }
        // console.log(this.current_url)
    },
    computed: {},
    mounted() { },
    methods: {
        jumpUrl(data) {
            console.log('点击导航菜单');
            if (data.name == "监察审计") {
                location.href = "http://zyecp.com/admin/loginJCSJ";
            } else if (data.name == "e购超市") {
                this.$router.push({
                    name: "goodsList",
                    query: {
                        searchType: 0,
                        keyword: "",
                    },
                });
            } else {
                this.$router.push({
                    path: data.link,
                });
            }
        },
        goDetail(params) {
            this.$router.push({
                name: "goodsList",
                query: {
                    searchType: "gcIdSearch",
                    keyword: params.gcIdpath,
                },
            });
        },
    },
};
</script>
<style scoped lang="scss">
.navbar-container {
    width: 100%;
    margin: 0 auto;
    background: #ffffff;

    .navbar-box {
        width: 1200px;
        margin: 0 auto;
        height: 45px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: 2px solid #e63535;

        .all-menu {
            width: 220px;
            height: 100%;
            line-height: 45px;
            text-indent: 66px;
            font-size: 16px;
            color: #fff;
            background: url(../assets/images/indexicon/navbar_icon.png) 40px 14px no-repeat #e63535;
            cursor: pointer;

            &:hover {
                .all-menu-list {
                    display: block;
                }
            }

            .all-menu-list-hide {
                display: none;
            }

            .all-menu-list {
                width: 100%;
                height: 496px;
                margin-left: -1px;
                border-left: 1px solid #dcdfe6;
                border-right: 1px solid #dcdfe6;
                background: #ffffff;
                position: relative;
                // box-sizing: border-box;
                z-index: 4;

                .all-list-item {
                    width: 100%;
                    height: 55px;
                    line-height: 55px;
                    background: #ffffff;
                    color: #333333;
                    font-size: 14px;
                    text-indent: 0;
                    box-sizing: border-box;
                    padding: 0 0 0 30px;

                    .first-title {
                        margin-right: 5px;

                        &:hover {
                            color: #d21d27;
                        }
                    }

                    .list-icon {
                        font-size: 18px;
                        line-height: 55px;
                        margin-right: 4px;
                    }

                    &:hover {
                        background: #ffe6e6;
                        color: #000000;

                        .all-list-son {
                            display: block;
                        }

                        i {
                            color: #d21d27;
                        }
                    }

                    .all-list-son {
                        display: none;
                        width: 980px;
                        height: 500px;
                        padding: 0 28px;
                        box-sizing: border-box;
                        background: #ffffff;
                        position: absolute;
                        top: 0;
                        left: 220px;
                        overflow-y: scroll;
                        overflow: auto;
                        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

                        .son-title {
                            font-size: 18px;
                            color: #999999;
                            font-weight: bold;
                            margin-right: 10px;
                        }

                        .list-son-detail {
                            .son-detail-title {
                                .second-title {
                                    font-size: 16px;
                                    color: #333333;
                                    font-weight: bold;

                                    &:hover {
                                        text-decoration: underline;
                                    }
                                }

                                .third-box {
                                    width: 100%;
                                    line-height: 40px !important;

                                    .third-title {
                                        font-size: 14px;
                                        color: #333333;
                                        height: 30px;
                                        line-height: 30px;
                                        margin-right: 25px;
                                        display: inline-block;

                                        &:hover {
                                            text-decoration: underline;
                                            color: #e63535;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .home-menu {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-left: 60px;

            .home-menu-item-active {
                color: #e63535 !important;
            }

            .home-menu-item {
                //font-size: 16px;
                font-size: 20px;
                color: #515151;
                font-weight: 600;
                padding: 0 18px 0 0;
                cursor: pointer;

                &:last-child {
                    padding-right: 0;
                }

                &:hover {
                    color: #e63535;
                }

                i {
                    color: #e63535;
                    // font-size: 20px;
                    font-size: 20px;
                    margin-right: 5px;
                }

                .icon {
                    width: 20px;
                    height: 21px;
                    margin-right: 5px;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/navbar.vue